// extracted by mini-css-extract-plugin
module.exports = {"bubble":"notificationsBubble-module_bubble_16W2b"};